import { cn } from "@shared/ui"

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

export function Card({ children, className, disabled, ...props }: CardProps) {
  return (
    <div
      className={cn(
        "flex h-[162px] cursor-pointer flex-col justify-center rounded-xl border bg-[#FBFBFB] p-6 shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] transition-all duration-300 hover:border-[#EAECF0] hover:bg-[#EFF6FF] hover:shadow-[0px_8px_0px_0px_#0B5CF3,0px_1px_3px_0px_rgba(16,24,40,0.10)]",
        disabled &&
          "cursor-not-allowed text-[#364152] opacity-50 hover:bg-[#FBFBFB] hover:shadow-none",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
